export default __webpack_public_path__ + "static/media/fuel-filter.2205e09b.jpg";